import { render } from "./DefaultDisplay.vue?vue&type=template&id=0871d074&scoped=true"
import script from "./DefaultDisplay.vue?vue&type=script&lang=js"
export * from "./DefaultDisplay.vue?vue&type=script&lang=js"

import "./DefaultDisplay.vue?vue&type=style&index=0&id=0871d074&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0871d074"]])

export default __exports__